// extracted by mini-css-extract-plugin
export var cardSelected = "_gp-2";
export var image = "_gp-1";
export var table = "_gp-0";